import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./primitives";
import { LOGO_MARK } from "../lib/site";

export const CTABand = ({ heading, text, primary, secondary, testid = "cta-band" }) => (
    <section data-testid={testid} className="grain relative overflow-hidden bg-[#07211A] py-24 sm:py-32">
        <img
            src={LOGO_MARK}
            alt=""
            aria-hidden="true"
            className="pointer-events-none absolute -left-28 bottom-[-140px] w-[420px] opacity-[0.07]"
        />
        <div
            aria-hidden="true"
            className="absolute inset-0 bg-[radial-gradient(50%_60%_at_80%_20%,rgba(194,161,96,0.12),transparent_65%)]"
        />
        <div className="relative z-[2] mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
            <Reveal>
                <h2 className="font-display max-w-3xl text-3xl font-medium leading-tight tracking-tight text-[#FDFBF7] sm:text-4xl lg:text-5xl">
                    {heading}
                </h2>
            </Reveal>
            {text && (
                <Reveal delay={0.15}>
                    <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#FDFBF7]/70 md:text-lg">
                        {text}
                    </p>
                </Reveal>
            )}
            <Reveal delay={0.28}>
                <div className="mt-10 flex flex-wrap gap-4">
                    {primary && (
                        <Link to={primary.to} data-testid={`${testid}-primary`} className="btn-gold">
                            {primary.label}
                            <ArrowUpRight size={16} aria-hidden="true" />
                        </Link>
                    )}
                    {secondary && (
                        <Link to={secondary.to} data-testid={`${testid}-secondary`} className="btn-outline-light">
                            {secondary.label}
                        </Link>
                    )}
                </div>
            </Reveal>
        </div>
    </section>
);
